export default __webpack_public_path__ + "static/media/dropdown-bg.8b0d4c5c.webp";